import { render } from "./Main.vue?vue&type=template&id=1f1fccb6"
const script = {}

import exportComponent from "/builds/fa4daba7/0/develop/front_payments_config/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__